import _ from 'lodash';
import React, { Component } from 'react';

import ReactTooltip from 'react-tooltip';

import { Switch } from '../../shared';

import {
  getIcon,
  currentUserIsSuperAdmin,
  appConfig,
} from '../../../util';

class AssessmentSetupSection extends Component{

  state = {

  }

  render(){

    const {
      assessmentName,
      assessmentAccessToken,
      talentAssessmentSectionEnabled,
      skillsAssessmentSectionEnabled,
      experinceAssessmentSectionEnabled,
      openEndedAssessmentSectionEnabled,
    } = this.props.orgSettings;

    return(
      <div className="assessment-setup">
        <p>Manage assessment setup options for this organization.</p>
        <div className="section-header">ACCESS</div>

        <div className="velocity-form">
          <div className="form-group">

            <div className="input-group quarter-width">
              <label>Assessment Name</label>
              <input
                type="text"
                placeholder="Assessment Name"
                value={`${assessmentName || ''}`}
                disabled={!currentUserIsSuperAdmin()}
                onChange={() => { this.props.updateSettings({ assessmentName }); }}
              />
            </div>
            <div className="input-group quarter-width">
              <label>Access Token</label>
              <input disabled type="text" placeholder="Not Implemented" />
            </div>
            <div className="input-group half-width is-last-in-row">
              <label>Access Url</label>
              <input
                className="select-all-on-click"
                onClick={() => { this.accessUrlInput.select(); }}
                ref={input => { this.accessUrlInput = input; }}
                type="text"
                value={`${appConfig().APP_URL}/a/${assessmentName}`}
                onChange={() => {}}
              />
            </div>
          </div>
        </div>

        <div className="section-header">ENABLED Components</div>
        <div className="velocity-form">
          <div className="form-group">

            <div className="input-group quarter-width switch-input-group">
              <label>Talent</label>
              <Switch
                id="some-switch"
                checked={talentAssessmentSectionEnabled || false}
                onChange={checked => { this.props.updateSettings({ talentAssessmentSectionEnabled: checked }); } }
              />
            </div>
            <div className="input-group quarter-width switch-input-group">
              <label>Skills</label>
              <Switch
                id="some-switch"
                checked={skillsAssessmentSectionEnabled || false}
                onChange={checked => { this.props.updateSettings({ skillsAssessmentSectionEnabled: checked }); } }
              />
            </div>
            <div className="input-group quarter-width switch-input-group">
              <label>Experience</label>
              <Switch
                id="some-switch"
                checked={experinceAssessmentSectionEnabled || false}
                onChange={checked => { this.props.updateSettings({ experinceAssessmentSectionEnabled: checked }); } }
              />
            </div>
            <div className="input-group quarter-width switch-input-group">
              <label>Open Ended</label>
              <Switch
                id="some-switch"
                checked={openEndedAssessmentSectionEnabled || false}
                onChange={checked => { this.props.updateSettings({ openEndedAssessmentSectionEnabled: checked }); } }
              />
            </div>
          </div>
        </div>

      </div>
    )
  }
}

export default AssessmentSetupSection;



// WEBPACK FOOTER //
// ./src/components/settings/sections/assessmentSetupSection.js